{{ tema().navn }}
@if (tema().beskrivelse) {
  <div class="kontainer" [class.venstre]="erPaaVenstreSide()">
    <div class="beskrivelse">
      <html-formatert [innhold]="tema().beskrivelse" data-testid="tema-beskrivelse"></html-formatert>
    </div>
  </div>
}
